export default "__VITE_ASSET__CKkZ8f$l__"